export const sprites = {
  frames: {
    'badges/connected.svg': {
      frame: { x: 0, y: 0, w: 24, h: 24 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 24, h: 24 },
      sourceSize: { w: 24, h: 24 },
    },
    'badges/connecting_01.png': {
      frame: { x: 24, y: 0, w: 24, h: 25 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 24, h: 25 },
      sourceSize: { w: 24, h: 25 },
    },
    'badges/connecting_02.png': {
      frame: { x: 48, y: 0, w: 24, h: 25 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 24, h: 25 },
      sourceSize: { w: 24, h: 25 },
    },
    'badges/connecting_03.png': {
      frame: { x: 72, y: 0, w: 24, h: 25 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 24, h: 25 },
      sourceSize: { w: 24, h: 25 },
    },
    'badges/connecting_spritesheet.png': {
      frame: { x: 96, y: 0, w: 72, h: 25 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 72, h: 25 },
      sourceSize: { w: 72, h: 25 },
    },
    'badges/intermittent.svg': {
      frame: { x: 168, y: 0, w: 24, h: 24 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 24, h: 24 },
      sourceSize: { w: 24, h: 24 },
    },
    'circle.png': {
      frame: { x: 0, y: 25, w: 400, h: 362 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 400, h: 362 },
      sourceSize: { w: 400, h: 362 },
    },
    'custom-arrow.png': {
      frame: { x: 0, y: 387, w: 34, h: 34 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 34, h: 34 },
      sourceSize: { w: 34, h: 34 },
    },
    'disconnected_indicator.svg': {
      frame: { x: 34, y: 387, w: 65, h: 64 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 65, h: 64 },
      sourceSize: { w: 65, h: 64 },
    },
    'group-activity.svg': {
      frame: { x: 99, y: 387, w: 74, h: 72 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 74, h: 72 },
      sourceSize: { w: 74, h: 72 },
    },
    'hover-icon-background.svg': {
      frame: { x: 173, y: 387, w: 40, h: 40 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 40, h: 40 },
      sourceSize: { w: 40, h: 40 },
    },
    'mic_off.svg': {
      frame: { x: 213, y: 387, w: 31, h: 33 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 31, h: 33 },
      sourceSize: { w: 31, h: 33 },
    },
    'presenter_indicator.svg': {
      frame: { x: 244, y: 387, w: 80, h: 80 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 80, h: 80 },
      sourceSize: { w: 80, h: 80 },
    },
    'teleport-ocean.svg': {
      frame: { x: 324, y: 387, w: 25, h: 24 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 25, h: 24 },
      sourceSize: { w: 25, h: 24 },
    },
    'video_off.svg': {
      frame: { x: 349, y: 387, w: 31, h: 32 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 31, h: 32 },
      sourceSize: { w: 31, h: 32 },
    },
    'video_off_big.svg': {
      frame: { x: 380, y: 387, w: 31, h: 32 },
      rotated: false,
      trimmed: false,
      spriteSourceSize: { x: 0, y: 0, w: 31, h: 32 },
      sourceSize: { w: 31, h: 32 },
    },
  },
  animations: {
    'badges/connecting': ['badges/connecting_01.png', 'badges/connecting_02.png', 'badges/connecting_03.png'],
  },
  meta: {
    app: 'https://www.codeandweb.com/texturepacker',
    version: '1.1',
    image: 'assets/pixi/sprites.png',
    format: 'RGBA8888',
    size: { w: 411, h: 467 },
    scale: '1',
    smartupdate:
      '$TexturePacker:SmartUpdate:60b86fccf1eef5899b4a238dc25339db:af15e6605c25a56bf27ac7beaf0c924b:1eabdf11f75e3a4fe3147baf7b5be24b$',
  },
};
